/*
 *   File : user-info.js
 *   Author URI : https://evoqins.com
 *   Description : User Information card
 *   Integrations : null
 *   Version : v1.1
 */

/*import packages*/
import { Fragment, useEffect, useState } from "react";

/* import components */
import Icon from "../Icon/icon";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import APIService from "../../Services/api-service";
import { toast } from "react-toastify";
import { DeleteMandate, EditEmailModal, EditPhoneModal, UpdateRelation } from "../Modal";
import { Modal } from "bootstrap";
import { configureStore } from "@reduxjs/toolkit";

const UserInfo = (props) => {

    const { state } = useLocation();
    const [hoveredBankIndex, setHoveredBankIndex] = useState(null);

    const ADMIN_PROFILE_DATA = useSelector(state => state.MT_ADMIN_STORE.ADMIN_PROFILE);
    console.log('ADMIN_PROFILE_DATA', ADMIN_PROFILE_DATA);

    const [deleteBankModal, setDeleteBankModal] = useState(false);
    const [bankId, setBankId] = useState(null);
    const [openRelationUpdateModal, setOpenRelationUpdateModal] = useState(false);
    const [relationType, setRelationType] = useState(1);
    const [profileModalType, setProfileModalType] = useState(null);

    console.log('state', state);

    useEffect(() => {
        if (deleteBankModal === true) {
            const modal = new Modal(document.getElementById("delete-mandate"), {});
            modal.show();
        }
    }, [deleteBankModal]);

    useEffect(() => {
        if (openRelationUpdateModal === true) {
            const modal = new Modal(document.getElementById("update-relation"), {});
            modal.show();
        }
    }, [openRelationUpdateModal]);

    useEffect(() => {
        switch (profileModalType) {
            case 1:
                new Modal(document.getElementById("update-email")).show();
                break;
            case 2:
                new Modal(document.getElementById("update-mobile")).show();
                break;
            default:
                break;
        }
    }, [profileModalType]);

    const _getNomineeAddress = (item) => {
        return [
            item.nominee_address_line1,
            item.nominee_address_line2,
            item.nominee_address_line3,
            item.nominee_city,
            item.nominee_state_name,
            item.nominee_pincode,
            item.nominee_country
        ].filter(Boolean).join(" ");
    };

    const _getNomineeDetails = (item) => ([
        { label: "Name", value: item.name },
        { label: "Relation", value: item.relationship },
        { label: "Date of Birth", value: item.date_of_birth_str },
        { label: "Allocation%", value: item.allocation },
        { label: "Guardian name", value: item.guardian_name },
        { label: "Guardian relationship", value: item.guardian_relationship },
        { label: "Guardian pan", value: item.guardian_pan },
        { label: "Mobile", value: item.nominee_mobile },
        { label: "Email", value: item.nominee_email },
        { label: "Email declaration", value: item.nominee_email_declaration },
        { label: "Mobile declaration", value: item.nominee_mobile_declaration },
        { label: "Proof type", value: item.nominee_proof_type },
        { label: "Proof number", value: item.nominee_proof_id },
        { label: "Address", value: _getNomineeAddress(item), className: "e-nominee-detail-address" },
    ]);



    function _closeDeleteBankModal() {
        setDeleteBankModal(false);
    }

    function _handleOtpSendBank(bank_id) {

        let url = 'bank/send-bank-otp';
        let payload = JSON.stringify({
            customer_id: state.user_id,
        });

        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                toast.dismiss();
                toast.success('OTP sent successfully');
                setDeleteBankModal(true);
                setBankId(bank_id)

            } else {
                toast.error(response.message, { type: 'error' });
            }
        });
    };


    const _handleModals = (index) => {
        if (index === profileModalType) {
            setProfileModalType(null);
        } else {
            setProfileModalType(index);
        }
    };

    const _handleCloseProfileModal = () => {
        setProfileModalType(null);
    };


    const _handleDelete = (otp) => {
        let url = 'bank/delete-bank-account';
        let payload = JSON.stringify({
            customer_id: state.user_id,
            "bank_id": bankId,
            "otp": otp
        });
        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                toast.dismiss();
                toast.success('Successfully Deleted ', { type: 'success' });
                props.handleSuccess();
                if (document.querySelector(".modal-backdrop")) {
                    document.querySelector(".modal-backdrop").remove();
                    document.body.style.overflow = 'unset';
                };
                setDeleteBankModal(false);

            } else {
                toast.dismiss();
                toast.error(response.message, { type: 'error' });
            }
        });
    };


    const [bankData, setBankData] = useState([]);
    console.log('bankData', bankData);


    useEffect(() => {
        if (props.bankInfo?.length > 0) {
            setBankData(props.bankInfo);
        } else {
            setBankData([{
                bank_name: null,
                account_no: null,
                account_type: null,
                ifsc: null,
                branch: null
            }]);
        }
    }, [props.bankInfo]);

    // API - get zone
    // async function _getZoneOptions() {
    //     let data = await _getZone();
    //     const modified_data = data.map((item) => {
    //         return {
    //             value: item.id,
    //             label: item.name
    //         }
    //     })
    //     setZoneOptions(modified_data);
    //     setShowRMModal(true);;
    // }

    // const _getZoneOptions = () => {

    // }

    const _openRelationUpdateModal = (type) => {
        setRelationType(type);
        setOpenRelationUpdateModal(true);
    };

    function _closeRelationUpdateModal() {
        setOpenRelationUpdateModal(false);
        setRelationType(1);
    };

    const _callBackRelationSuccess = () => {
        props.updateDetail();
    };


    return (
        <Fragment>
            {
                props.type === 1 ?
                    <div className="border-all border-bright-gray padding-24px-all border-radius-16px">
                        <h5 className="mb-0 e-poppins-medium e-font-16 line-height-16px color-light-black ">
                            Personal information

                        </h5>
                        <div className="row padding-24px-top">
                            <div className="col-lg-2 col-md-4 col-6 pb-lg-0 pb-md-3 pb-4">
                                <p className="e-font-14 e-poppins-regular line-height-14px color-light-black my-0">
                                    Name
                                </p>
                                <h6 className="e-poppins-medium e-font-14 line-height-14px color-light-black mb-0 mt-2">
                                    {props.basicInfo.name}
                                </h6>
                            </div>
                            <div className="col-lg-2 col-md-4 col-6 pb-lg-0 pb-md-3 pb-4">
                                <p className="e-font-14 e-poppins-regular line-height-14px color-light-black my-0">
                                    PAN number
                                </p>
                                <h6 className="e-poppins-medium e-font-14 line-height-14px color-light-black mb-0 mt-2">
                                    {props.basicInfo.pan}
                                </h6>
                            </div>
                            <div className="col-lg-3 col-md-4 col-6 pb-lg-0 pb-md-3 pb-4">
                                <p className="e-font-14 e-poppins-regular line-height-14px color-light-black my-0">
                                    Date of birth
                                </p>
                                <h6 className="e-poppins-medium e-font-14 line-height-14px color-light-black mb-0 mt-2">
                                    {props.basicInfo.dob}
                                </h6>
                            </div>
                            <div className="col-lg-2 col-md-4 col-6 pb-lg-0 pb-md-3 pb-4">
                                <p className="e-font-14 e-poppins-regular line-height-14px color-light-black my-0">
                                    Gender
                                </p>
                                <h6 className="e-poppins-medium e-font-14  line-height-14px color-light-black mb-0 mt-2">
                                    {props.basicInfo.gender}
                                    {
                                        props.basicInfo.gender_mismatch === true &&
                                        <span className="e-tool-tip-container position-relative"
                                            data-tooltip-content="Gender is not same as the value received from Digilocker">
                                            ⚠️
                                        </span>
                                    }
                                </h6>
                            </div>
                            <div className="col-lg-2 col-md-4 col-6 pb-lg-0 pb-md-3 pb-4">
                                <p className="e-font-14 e-poppins-regular line-height-14px color-light-black my-0">
                                    Marital status
                                </p>
                                <h6 className="e-poppins-medium e-font-14 line-height-14px color-light-black mb-0 mt-2">
                                    {props.basicInfo.marital_status}
                                </h6>
                            </div>
                        </div>
                        <div className="row padding-24px-top">
                            {/* <div className="col-lg-2 col-md-4 col-6 pb-lg-0 pb-md-3 pb-4">
                                <p className="e-font-14 e-poppins-regular line-height-14px color-light-black my-0">
                                    Marital status
                                </p>
                                <h6 className="e-poppins-medium e-font-14 line-height-14px color-light-black mb-0 mt-2">
                                    {props.basicInfo.marital_status}
                                </h6>
                            </div> */}

                            <div className="col-lg-2 col-md-4 col-6 pb-lg-0 pb-md-3 pb-4">
                                <div>
                                    <p className="e-font-14 e-poppins-regular line-height-14px color-light-black my-0">
                                        Email relation
                                    </p>

                                    <div className="d-flex align-items-end gap-5">
                                        <h6 className="e-poppins-medium e-font-14 line-height-18px color-light-black mb-0 mt-2">
                                            {props.basicInfo.email_relation}
                                        </h6>
                                        {
                                            props.basicInfo?.is_email_rel_editable === true &&
                                            (ADMIN_PROFILE_DATA?.admin_type_id === 1 || ADMIN_PROFILE_DATA?.admin_type_id === 2) &&
                                            props.basicInfo?.demat !== true && (
                                                <Icon icon="Pen-square"
                                                    size={24}
                                                    onClick={() => _openRelationUpdateModal(1)}
                                                    className="ms-1 cursor-pointer" />
                                            )
                                        }
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-2 col-md-4 col-6 pb-lg-0 pb-md-3 pb-4">
                                <div>
                                    <p className="e-font-14 e-poppins-regular line-height-14px color-light-black my-0">
                                        Mobile relation
                                    </p>

                                    <div className="d-flex align-items-end gap-5">
                                        <h6 className="e-poppins-medium e-font-14 line-height-18px color-light-black mb-0 mt-2">
                                            {props.basicInfo.mobile_relation}
                                        </h6>
                                        {
                                            props.basicInfo?.is_mobile_rel_editable === true &&
                                            (ADMIN_PROFILE_DATA?.admin_type_id === 1 || ADMIN_PROFILE_DATA?.admin_type_id === 2) &&
                                            props.basicInfo?.demat !== true && (
                                                <Icon
                                                    icon="Pen-square"
                                                    size={24}
                                                    onClick={() => _openRelationUpdateModal(2)}
                                                    className="ms-1 cursor-pointer"
                                                />
                                            )
                                        }

                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-4 col-6 pb-lg-0 pb-md-3 pb-4">
                                <div>
                                    <p className="e-font-14 e-poppins-regular line-height-14px color-light-black my-0">
                                        Email
                                    </p>

                                    <div className="d-flex align-items-end gap-3">
                                        <h6 className="e-poppins-medium e-font-14 line-height-18px color-light-black mb-0 mt-2 word-break">
                                            {props.basicInfo.email}
                                        </h6>


                                        {
                                            (ADMIN_PROFILE_DATA?.admin_type_id === 1 || ADMIN_PROFILE_DATA?.admin_type_id === 2) &&
                                            props.basicInfo?.email !== "-" &&
                                            props.basicInfo?.demat !== true && (
                                                <Icon icon="Pen-square"
                                                    size={24}
                                                    onClick={() => _handleModals(1)}
                                                    className="ms-1 cursor-pointer" />
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-4 col-6 pb-lg-0 pb-md-3 pb-4">
                                <div>
                                    <p className="e-font-14 e-poppins-regular line-height-14px color-light-black my-0">
                                        Mobile
                                    </p>

                                    <div className="d-flex align-items-end gap-3">
                                        <h6 className="e-poppins-medium e-font-14 line-height-18px color-light-black mb-0 mt-2">
                                            {props.basicInfo.mobile}
                                        </h6>
                                        {/* <Icon icon="Pen-square"
                                            size={24}
                                            onClick={() => _handleModals(2)}
                                            className="ms-1 cursor-pointer" /> */}
                                        {
                                            (ADMIN_PROFILE_DATA?.admin_type_id === 1 || ADMIN_PROFILE_DATA?.admin_type_id === 2) &&
                                            props.basicInfo?.mobile !== "-" &&
                                            props.basicInfo?.demat !== true && (
                                                <Icon
                                                    icon="Pen-square"
                                                    size={24}
                                                    onClick={() => _handleModals(2)}
                                                    className="ms-1 cursor-pointer"
                                                />
                                            )
                                        }

                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-4 col-6 pb-lg-0 pb-md-3 pb-4">
                                <p className="e-font-14 e-poppins-regular line-height-14px color-light-black my-0">
                                    Address
                                </p>
                                {/* <h6 className="e-poppins-medium e-font-14 line-height-18px color-light-black mb-0 mt-2">
                                    {props.basicInfo.address}
                                </h6> */}
                                <h6
                                    className="e-poppins-medium e-font-14 line-height-18px color-light-black mb-0 mt-2"
                                    style={{
                                        wordBreak: "break-word",
                                        overflowWrap: "break-word"
                                    }}
                                >
                                    {props.basicInfo.address}
                                </h6>
                            </div>
                        </div>
                    </div>
                    :
                    props.type === 2 ?
                        <div className="border-all border-bright-gray padding-24px-all border-radius-16px">
                            <h5 className="mb-0 e-poppins-medium e-font-16 line-height-16px color-light-black">
                                Bank details
                            </h5>
                            <div className="row padding-24px-top">
                                <div className="col-lg-2 col-md-4 col-6 pb-lg-0 pb-md-4 pb-4">
                                    <p className="e-font-14 e-poppins-regular line-height-14px color-light-black my-0">
                                        Bank
                                    </p>
                                </div>
                                <div className="col-lg-2 col-md-4 col-6 pb-lg-0 pb-md-4 pb-4">
                                    <p className="e-font-14 e-poppins-regular line-height-14px color-light-black my-0">
                                        Account No
                                    </p>
                                </div>
                                <div className="col-lg-2 col-md-4 col-6 pb-lg-0 pb-md-4 pb-4">
                                    <p className="e-font-14 e-poppins-regular line-height-14px color-light-black my-0">
                                        Account type
                                    </p>
                                </div>
                                <div className="col-lg-2 col-md-4 col-6 pb-lg-0 pb-md-4 pb-4">
                                    <p className="e-font-14 e-poppins-regular line-height-14px color-light-black my-0">
                                        IFSC
                                    </p>
                                </div>
                                <div className="col-lg-2 col-md-4 col-6 pb-lg-0 pb-md-4 pb-4">
                                    <p className="e-font-14 e-poppins-regular line-height-14px color-light-black my-0">
                                        Branch
                                    </p>
                                </div>
                                <div className="col-lg-2 col-md-4 col-6 pb-lg-0 pb-md-4 pb-4">
                                    <p className="e-font-14 e-poppins-regular line-height-14px color-light-black my-0">
                                        Action
                                    </p>
                                </div>
                                {bankData.map((item, key) =>
                                (
                                    <div className={`col-12   ${key === 0 ? "mt-2" : "mt-3"}`} key={key}>
                                        <div className="row">
                                            <div className="col-lg-2 col-md-4 col-6 pb-lg-0 pb-md-4 pb-4">
                                                <h6 className="e-poppins-medium e-font-14 line-height-14px color-light-black mb-0 mt-2">
                                                    {item.bank_name || "-"}
                                                </h6>
                                            </div>
                                            <div className="col-lg-2 col-md-4 col-6 pb-lg-0 pb-md-4 pb-4">
                                                <h6 className="e-poppins-medium e-font-14 line-height-14px color-light-black mb-0 mt-2">
                                                    {item.masked_account_number || '-'}
                                                </h6>
                                            </div>
                                            <div className="col-lg-2 col-md-4 col-6 pb-lg-0 pb-md-4 pb-4">
                                                <h6 className="e-poppins-medium e-font-14 line-height-14px color-light-black mb-0 mt-2">
                                                    {item.account_type_label || '-'}
                                                </h6>
                                            </div>
                                            <div className="col-lg-2 col-md-4 col-6 pb-lg-0 pb-md-4 pb-4">
                                                <h6 className="e-poppins-medium e-font-14  line-height-14px color-light-black mb-0 mt-2">
                                                    {item.ifsc_code || '-'}
                                                </h6>
                                            </div>
                                            <div className="col-lg-2 col-md-4 col-6 pb-lg-0 pb-md-4 pb-4">
                                                <h6 className="e-poppins-medium e-font-14  line-height-14px color-light-black mb-0 mt-2">
                                                    {item.branch_name || '-'}
                                                </h6>
                                            </div>

                                            {props.bankInfo?.length > 0 &&
                                                (ADMIN_PROFILE_DATA?.admin_type_id === 2 || ADMIN_PROFILE_DATA?.admin_type_id === 1) && item.primary === false &&
                                                (
                                                    <div className="col-lg-2 col-md-4 col-6 pb-lg-0 pb-md-4 my-auto pb-4 ">
                                                        <p
                                                            className={`line-height-16px e-poppins-regular e-font-14 cursor-pointer my-0 position-relative h-fit-content
                                                         ${hoveredBankIndex === key ? "color-red" : "color-primary-color"}`}
                                                            onMouseEnter={() => setHoveredBankIndex(key)}
                                                            onMouseLeave={() => setHoveredBankIndex(null)}
                                                            onClick={() => _handleOtpSendBank(item.bank_id)}
                                                        >
                                                            Delete bank
                                                            <Icon
                                                                icon={hoveredBankIndex === key ? "delete-red" : "delete"}
                                                                size={24}
                                                                className="ms-1"
                                                            />
                                                        </p>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                )

                                )}
                            </div>
                        </div>
                        :
                        <div className="border-all border-bright-gray padding-24px-all border-radius-16px">
                            {
                                Object.keys(props.nomineeInfo).length === 0 ?
                                    <Fragment>
                                        <h5 className="mb-0 e-poppins-medium e-font-16 line-height-16px color-light-black">
                                            Nominees
                                        </h5>
                                        <p className="e-poppins-regular e-font-14 line-height-14px mb-0 mt-3">No nominee added</p>
                                    </Fragment>
                                    : props.nomineeInfo.skip_nominee === true ?
                                        <Fragment>
                                            <h5 className="mb-0 e-poppins-medium e-font-16 line-height-16px color-light-black">
                                                Nominees
                                            </h5>
                                            <p className="e-poppins-regular e-font-14 line-height-14px mb-0 mt-3">The customer has opted out of nominee</p>
                                        </Fragment>
                                        :
                                        <Fragment>
                                            <h5 className="mb-0 e-poppins-medium e-font-16 line-height-16px color-light-black">
                                                Nominees ({props.nomineeInfo.total_nominees})
                                            </h5>

                                            <div className="e-nominees-list">
                                                {
                                                    props.nomineeInfo.nominees.map((item, key) =>
                                                        <div className="e-nominee-detail-card" key={key}>
                                                            {
                                                                _getNomineeDetails(item).map((detail) =>
                                                                    <div className={`e-nominee-detail ${detail.className || ""}`} key={detail.label}>
                                                                        <p className="e-font-14 e-poppins-regular line-height-18px color-light-black my-0">
                                                                            {detail.label}
                                                                        </p>
                                                                        <h6 className="e-poppins-medium e-font-14 line-height-20px color-light-black mb-0 mt-1">
                                                                            {detail.value || "-"}
                                                                        </h6>
                                                                    </div>
                                                                )
                                                            }
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </Fragment>
                            }
                        </div>
            }

            {
                deleteBankModal === true &&
                <DeleteMandate
                    // bankId={bankId}
                    type={1}
                    onResend={_handleOtpSendBank}
                    onVerify={(otp) => _handleDelete(otp)}
                    close={_closeDeleteBankModal}
                />

            }

            {
                openRelationUpdateModal === true && (
                    <UpdateRelation type={relationType}
                        basicInfo={props.basicInfo}
                        success={_callBackRelationSuccess}
                        close={_closeRelationUpdateModal} />
                )
            }

            {profileModalType === 2 && (
                <EditPhoneModal
                    basicInfo={props.basicInfo}
                    phone={props.basicInfo.mobile}
                    onCloseModal={_handleCloseProfileModal}
                    phoneAdded={() => {
                        _handleCloseProfileModal();
                        // _fetchProfile();
                        props.updateDetail();
                    }}
                />
            )}

            {profileModalType === 1 && (
                <EditEmailModal
                    basicInfo={props.basicInfo}
                    email={props.basicInfo.email}
                    onCloseModal={_handleCloseProfileModal}
                    mailAdded={() => {
                        _handleCloseProfileModal();
                        // _fetchProfile();
                        props.updateDetail();
                    }}
                />
            )}

        </Fragment>
    )
}

UserInfo.defaultProps = {
    basicInfo: {
        first_name: "",
        last_name: "",
        pan_number: "",
        dob: "",
        gender: "",
        marital_status: "",
        address: "",

    },
    bankInfo: [{
        bank_name: null,
        account_no: null,
        account_type: null,
        ifsc: null,
        branch: null
    }],
    nomineeInfo: []
}

export default UserInfo;
